export const slotGamesDevelopmentSuperiorTextContent = {
  headingText: "Top-Notch Slot Games Development",
  btnText: "Hire Slot Games Developers",
  content: [
    {
      numberText: "13+",
      titleText: "Years of Expertise",
    },
    {
      numberText: "600+",
      titleText: "Overall Projects",
    },
    {
      numberText: "500+",
      titleText: "Professionals",
    },
    {
      numberText: "45+",
      titleText: "Countries Served",
    },
    {
      numberText: "100+",
      titleText: "Games Developed",
    },
  ],
};